export default __webpack_public_path__ + "f3b84516bf8b953b908b67ce8d2f9cb0.png";